// 仅供 PC 产品列表使用；筛选和排序始终由服务端在分页之前完成。
function text(value) {
  return value == null ? '' : String(value).trim()
}

function uniqueValues(values) {
  return [...new Set((Array.isArray(values) ? values : [])
    .filter(value => typeof value === 'string' || typeof value === 'number')
    .map(text).filter(Boolean))]
}

function numericText(value) {
  const result = text(value)
  return /^[+-]?[0-9]{1,18}([.][0-9]{1,9})?$/.test(result)
    ? result : null
}

function compareDecimal(left, right) {
  // 固定位字符串比较，避免 18 位整数经 Number 转换后丢失精度。
  const parts = value => {
    const [integer, decimal = ''] = value.replace(/^[+-]/, '').split('.')
    const magnitude = integer.padStart(18, '0') + decimal.padEnd(9, '0')
    return { magnitude, negative: value[0] === '-' && /[1-9]/.test(magnitude) }
  }
  const a = parts(left)
  const b = parts(right)
  if (a.negative !== b.negative) return a.negative ? -1 : 1
  const order = a.magnitude === b.magnitude ? 0 : (a.magnitude > b.magnitude ? 1 : -1)
  return a.negative ? -order : order
}

function validateRange(min, max) {
  const lower = text(min)
  const upper = text(max)
  if (!lower && !upper) return '请填写最小值或最大值'
  if ((lower && numericText(lower) === null) || (upper && numericText(upper) === null)) return '请输入纯数字，最多18位整数及9位小数'
  if (lower && upper && compareDecimal(lower, upper) > 0) return '最小值不能大于最大值'
  return ''
}

function readListQuery(query = {}) {
  let filters = {}
  if (query.filters) {
    try { filters = JSON.parse(query.filters) } catch (e) { throw new Error('筛选条件无效，请清除后重选') }
    if (!filters || typeof filters !== 'object' || Array.isArray(filters)) throw new Error('筛选条件无效，请清除后重选')
  }
  for (const key of ['brands', 'packages', 'params']) {
    if (filters[key] != null && !Array.isArray(filters[key])) throw new Error('筛选条件无效，请清除后重选')
  }
  for (const key of ['brands', 'packages']) {
    if ((filters[key] || []).some(value => typeof value !== 'string' || !text(value))) throw new Error('筛选选项无效，请清除后重选')
  }
  const brands = filters.brands || [query.brand]
  const packages = filters.packages || [query.packageName]
  const parameters = (filters.params || []).map(item => {
    if (!item || typeof item.name !== 'string' || !text(item.name)) throw new Error('参数筛选条件无效，请清除后重选')
    if (item.values != null && (!Array.isArray(item.values) || item.values.some(value => typeof value !== 'string' || !text(value)))) throw new Error('参数选项无效，请清除后重选')
    const name = text(item.name)
    const values = uniqueValues(item.values)
    if (values.length) {
      if (text(item.min) || text(item.max)) throw new Error('同一参数不能同时使用选项和范围筛选')
      return { name, values }
    }
    const error = validateRange(item.min, item.max)
    if (error) throw new Error(`${name}：${error}`)
    return { name, min: text(item.min), max: text(item.max), unit: text(item.unit) }
  })
  if (new Set(parameters.map(item => item.name)).size !== parameters.length) throw new Error('参数筛选条件重复，请清除后重选')
  const page = Number(query.page)
  const size = Number(query.pageSize)
  return {
    brands: uniqueValues(brands), packages: uniqueValues(packages), parameters,
    page: Number.isSafeInteger(page) && page > 0 ? page : 1,
    pageSize: [20, 50, 100].includes(size) ? size : 20,
    sortField: ['stock', 'price'].includes(query.sortField) ? query.sortField : 'default',
    sortOrder: query.sortOrder === 'desc' ? 'desc' : 'asc'
  }
}

function filterQuery(filters) {
  return {
    filters: filters.brands.length || filters.packages.length || filters.parameters.length
      ? JSON.stringify({ brands: filters.brands, packages: filters.packages, params: filters.parameters }) : '',
    brand: '', packageName: ''
  }
}

function buildListRequest(query, state) {
  return {
    keyword: text(query.keyword), groupId: query.groupId || '', categoryId: query.categoryId || '', subCategoryId: query.subCategoryId || '',
    searchEvent: text(query.searchEvent),
    ...filterQuery(state), page: state.page, pageSize: state.pageSize,
    sortField: state.sortField, sortOrder: state.sortOrder
  }
}

// 以下参数不在 PC 商品筛选面板展示：商品档案元数据、外部链接类字段，
// 以及与更精确字段重复的冗余维度：
// 1. 「长度/宽度/高度」是带单位的文本，与纯数值的「长/宽/高」重复，后者可做范围筛选；
// 2. 「最大切换电压/最大切换电流」是复合文本（如 115V@AC、28V@DC），与拆分的（AC）（DC）字段表达同一指标；
// 3. 「配继电器型号」与「配用继电器/插座型号」为同类配件字段。
const HIDDEN_PARAM_NAMES = new Set([
  '长度', '宽度', '高度', '外形尺寸',
  '产品认证', '认证编号', '类型', '类型说明', '产品特性', '安装类型', '电气连接方式',
  '原始封装', '包装方式', '配套继电器系列', '配用继电器/插座型号', '配继电器型号',
  '最大切换电压', '最大切换电流',
  '官网系列型号', '官网链接', '数据手册链接'
])

function normalizeFilterOptions(data) {
  const source = data || {}
  const names = new Set()
  const parameters = (Array.isArray(source.params) ? source.params : []).reduce((result, item) => {
    if (!item || !text(item.name) || names.has(text(item.name))) return result
    const name = text(item.name)
    names.add(name)
    // 屏蔽项不进入筛选项，已通过链接带入的条件仍按原有逻辑保留为可清除的卡片。
    if (HIDDEN_PARAM_NAMES.has(name)) return result
    // JSON 数字在 JS 中可能显示为指数；只转换接口元数据，输入框仍严格拒绝指数。
    const boundaryText = value => typeof value === 'number' && Number.isFinite(value) ? value.toFixed(9).replace(/\.?0+$/, '') : text(value)
    const min = boundaryText(item.min)
    const max = boundaryText(item.max)
    const numericRanges = item.numeric === true && min !== '' && max !== '' && !validateRange(min, max)
      ? [{ unit: text(item.unit), min, max }] : []
    result.push({ name, values: uniqueValues(item.values), unit: text(item.unit), numericRanges })
    return result
  }, [])
  return {
    categoryIds: Array.isArray(source.categoryIds) ? source.categoryIds : [],
    subCategoryIds: Array.isArray(source.subCategoryIds) ? source.subCategoryIds : [],
    brands: uniqueValues(source.brands), packages: uniqueValues(source.packages), parameters
  }
}

function displayParamValue(value, unit) {
  const raw = text(value)
  const suffix = text(unit)
  // 尊重后台独立单位，范围值和公差同样展示；已有单位的原文不重复追加。
  return raw && suffix && !raw.includes(suffix) ? `${raw} ${suffix}` : raw
}

function displayParamName(value) {
  const name = text(value)
  return name === '厂牌' ? '品牌' : name
}

function productRows(product) {
  const rowLimit = 5
  const params = Array.isArray(product.params) ? product.params : []
  const result = params.reduce((rows, item, index) => {
    if (rows.length >= rowLimit) return rows
    if (!item || (item.isVisible != null && Number(item.isVisible) !== 1)) return rows
    const label = displayParamName(item.paramName)
    const value = displayParamValue(item.paramValue, item.unit)
    if (label && value) rows.push({ key: `param-${item.id == null ? index : item.id}-${index}`, label, value })
    return rows
  }, [])
  const description = text(product.summary) || text(product.desc)
  if (description && result.length < rowLimit) result.push({ key: 'description', label: '描述', value: description })
  return result
}

module.exports = { HIDDEN_PARAM_NAMES, uniqueValues, validateRange, readListQuery, filterQuery, buildListRequest, normalizeFilterOptions, displayParamName, displayParamValue, productRows }
